"use client";

import clsx from "clsx";
import { useAni } from "@/context/AniContext";
import { Button } from "@/components/ui/button/Button";
import {
  OutageBanner,
  OUTAGE_BANNER_INLINE_LINK_CLASS,
} from "@/components/ui/outage-banner";
import { openOpenworkReseedConfirm, useOpenworkReseeding } from "./openworkDemoState";

export type OpenworkUserTestingBannerProps = {
  className?: string;
};

/** Slim sandbox strip on the OS workspace bar — reseed via inline link. */
export function OpenworkUserTestingBanner({ className }: OpenworkUserTestingBannerProps) {
  const isReseeding = useOpenworkReseeding();
  const { sendUserMessageToAni } = useAni();

  const openAniGuide = () => {
    sendUserMessageToAni("What should I do first?");
  };

  return (
    <OutageBanner
      variant="bar"
      title="User testing"
      className={className}
      aria-busy={isReseeding}
      data-testid="openwork-user-testing-banner"
      message={
        <>
          You&apos;re testing Ani with three client scenarios. Start wherever you like —{" "}
          <Button
            plain
            size="unstyled"
            type="button"
            onClick={openAniGuide}
            className={OUTAGE_BANNER_INLINE_LINK_CLASS}
            data-testid="openwork-user-testing-open-ani"
          >
            Ani will guide you
          </Button>
          . Support:{" "}
          <a href="mailto:samantha@ani.tech" className={OUTAGE_BANNER_INLINE_LINK_CLASS}>
            samantha@ani.tech
          </a>
          . To reset and restart,{" "}
          <Button
            plain
            size="unstyled"
            type="button"
            onClick={() => openOpenworkReseedConfirm()}
            disabled={isReseeding}
            data-testid="openwork-user-testing-reseed-open"
            className={clsx(OUTAGE_BANNER_INLINE_LINK_CLASS, "disabled:opacity-50")}
          >
            click here
          </Button>
          .
        </>
      }
    />
  );
}
